import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import DataContainer from '../../../../Utilities/DataContainer';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanSiteChangesV2({ isReadOnly }: IProps) {

    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;

    return (
        <>
            <Grid size={12}>
                <Typography variant="h6">Changes in Site Environment and Circumstances</Typography>
            </Grid>
            <Grid size={12}>
                <Typography variant="body1">Since the travel plan was implemented, have any of the following changes occurred?</Typography>
            </Grid>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["parkingChange", "parkingChangeDetails"]) && (
                        <Grid container size={12} >
                            <DataContainer title={"Parking Restriction Charges"}>
                                <RenderSelectField name="parkingChange" label="Has there been a change in local parking restrictions within walking distance of the site?" readOnly={isReadOnly} options={yesNoDropdown} />
                                <RenderTextField name="parkingChangeDetails" label="Details" readOnly={isReadOnly} labelSize={12} inputSize={12} multiLine={true} rows={4} alwaysShow={true} />
                            </DataContainer>
                        </Grid>
                    )}

                    {hasValues(["transportChange", "transportChangeDetails"]) && (
                        <Grid container size={12} >
                            <DataContainer title={"Sustainable Transport Changes"}>
                                <RenderSelectField name="transportChange" label="Has there been an increase or decrease in the provision of sustainable transport to and from the local area where the site is located? (this could include new footways/cycleways, changes to public transport frequencies and services, a new local transport hub, etc.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                <RenderTextField name="transportChangeDetails" label="Details" readOnly={isReadOnly} labelSize={12} inputSize={12} multiLine={true} rows={4} alwaysShow={true} />
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["envFactors", "envFactorsDetails"]) && (
                        <Grid container size={12} >
                            <DataContainer title={"Local or Environmental Changes"}>
                                <RenderSelectField name="envFactors" label="Are there any local or environmental factors that may have affected quantities and methods of travel to and from the site, especially since a previous survey at the site (if applicable)? (examples might include new local infrastructure, changes to local routes, pedestrianisation of local area, etc.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                <RenderTextField name="envFactorsDetails" label="Details" readOnly={isReadOnly} labelSize={12} inputSize={12} multiLine={true} rows={4} alwaysShow={true} />
                            </DataContainer>
                        </Grid>
                    )}

                    {hasValues(["staffChange", "staffChangeDetails"]) && (
                        <Grid container size={12} >
                            <DataContainer title={"Staff Changes"}>
                                <RenderSelectField name="staffChange" label="Has there been a material change in the numbers of on-site staff? (for example an increase or decrease in site size and/or activity, introduction of flexible/home working)" readOnly={isReadOnly} options={yesNoDropdown} />
                                <RenderTextField name="staffChangeDetails" label="Details" readOnly={isReadOnly} labelSize={12} inputSize={12} multiLine={true} rows={4} alwaysShow={true} />
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["siteFactors", "siteFactorsDetails"]) && (
                        <Grid container size={12} >
                            <DataContainer title={"Site Specific Changes"}>
                                <RenderSelectField name="siteFactors" label="Are there any site-specific factors that may have affected quantities and methods of travel to and from the site, especially since a previous survey at the site (if applicable)? Examples might include changes to site accesses, changes and additions to site facilities, on-site parking arrangements, etc.)" readOnly={isReadOnly} options={yesNoDropdown} />
                                <RenderTextField name="siteFactorsDetails" label="Details" readOnly={isReadOnly} labelSize={12} inputSize={12} multiLine={true} rows={4} alwaysShow={true} />
                            </DataContainer>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </>
    );
}
